export class BenutzerBenutzerrecht {
    bbr_id: number;
    benutzer: string;
    benutzer_id: number;
    benutzerrecht_id: number;
    benutzerrecht: string;
    vorname: string;
    nachname: string;
    current_user_id: number;
}

export class Benutzerrecht {
    benutzerrecht_id: number;
    bezeichnung: string;
}
